import { render, staticRenderFns } from "./AgentDetails.vue?vue&type=template&id=15b1c692&"
import script from "./AgentDetails.vue?vue&type=script&lang=js&"
export * from "./AgentDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15b1c692')) {
      api.createRecord('15b1c692', component.options)
    } else {
      api.reload('15b1c692', component.options)
    }
    module.hot.accept("./AgentDetails.vue?vue&type=template&id=15b1c692&", function () {
      api.rerender('15b1c692', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/layout/sidebarComponents/AgentDetails.vue"
export default component.exports